export default __webpack_public_path__ + "static/acc-opening-banner-mobile-0ab8cf154a6a4bf26258ab01e5cf2c6a.jpg";